import type { StorageType } from './StorageType';
import { defaultStorageType } from './StorageType';

export function getBrowserStorage(storageType: StorageType = defaultStorageType): Storage | undefined {
  try {
    return window[storageType];
  } catch {
    return undefined;
  }
}
